import React from 'react';

interface QuantoReceberSectionProps {
  scrollToSection: (id: string) => void;
}

export default function QuantoReceberSection({ scrollToSection }: QuantoReceberSectionProps) {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block bg-teal-50 text-teal-700 text-xs font-bold uppercase tracking-widest px-5 py-2 rounded-full mb-4">
            Possibilidade de Indenização
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 font-serif">
            Quanto você pode receber?
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Cada caso é único e analisado individualmente. A Justiça brasileira reconhece o direito à indenização em milhares de casos todos os anos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white rounded-2xl p-8 border-2 border-gray-200 hover:border-teal-400 transition-all duration-300 hover:shadow-xl">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-scales-3-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Danos Morais</h3>
                <p className="text-gray-600">Pelo transtorno, estresse e frustração causados</p>
              </div>
            </div>
            <p className="text-gray-700 leading-relaxed mb-4">
              A Justiça reconhece que atrasos, cancelamentos e outros problemas causam dano moral ao passageiro. Os valores variam conforme a gravidade do caso, tempo de atraso e circunstâncias específicas.
            </p>
            <div className="bg-teal-50 rounded-lg p-4 border border-teal-200">
              <p className="text-sm text-gray-700">
                <strong className="text-teal-700">Exemplos de valores já reconhecidos pela Justiça:</strong><br />
                De R$ 2.000 a R$ 15.000 ou mais, dependendo do caso
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 border-2 border-gray-200 hover:border-teal-400 transition-all duration-300 hover:shadow-xl">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-money-dollar-circle-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Danos Materiais</h3>
                <p className="text-gray-600">Pelos prejuízos financeiros comprovados</p>
              </div>
            </div>
            <p className="text-gray-700 leading-relaxed mb-4">
              Se você teve gastos extras por causa do problema (hotel, alimentação, transporte, compromissos perdidos), pode receber o reembolso desses valores.
            </p>
            <div className="bg-teal-50 rounded-lg p-4 border border-teal-200">
              <p className="text-sm text-gray-700">
                <strong className="text-teal-700">Exemplos de danos materiais:</strong><br />
                Hospedagem, refeições, táxi, remarcação de compromissos, diárias de trabalho perdidas
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-10 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">
            O valor da indenização depende do seu caso!
          </h3>
          <p className="text-lg text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            Não prometemos valores fixos porque cada situação é diferente. Nossa análise gratuita vai avaliar:<br />
            <strong>Tempo de atraso • Motivo do problema • Prejuízos causados • Jurisprudência aplicável</strong>
          </p>
          <button
            onClick={() => scrollToSection('contato')}
            className="inline-flex items-center gap-3 bg-teal-500 hover:bg-teal-600 text-white px-10 py-5 rounded-full text-lg font-bold uppercase transition-all duration-300 hover:scale-105 hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calculator-line text-xl"></i>
            Descobrir Quanto Posso Receber
          </button>
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500 max-w-4xl mx-auto leading-relaxed">
            <strong>Importante:</strong> Os valores mencionados são exemplos baseados em decisões judiciais reais, mas não representam garantia. Cada caso é analisado individualmente conforme as normas da ANAC, Código de Defesa do Consumidor e jurisprudência dos tribunais brasileiros.
          </p>
        </div>
      </div>
    </section>
  );
}
